import { updateListItem } from '../../../modules/bin/entityHandlers';
import update from '../../../helpers/update';
import { eventPriority } from './constants';

// Headline is a tier 1 concept, so any move out of the top tier clears it.
// Shared with the CSV bulk upload, which writes priorities straight into the
// form array without going through the grid's dropdown.
export const applyPriority = (organization, priority) => {
  organization.priority = priority;

  if (priority !== eventPriority[0].key) {
    organization.isHeadline = false;
  }

  return organization;
};

export const updateRecord = (state, key, itemId, model) => {
  if (key) {
    const newModel = updateListItem(state, itemId, key, model);
    if (newModel) {
      state = update(state, { [key]: newModel });
    }
  }
  return state;
};

export const updatePriorityRecord = (state, key, itemId, value) => {
  return updateRecord(state, key, itemId, {
    priority: { $set: value }
  });
};
